import { Component,  } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-unavailable-find-device-modal',
  templateUrl: './unavailable-find-device-modal.component.html',
  styleUrls: ['./unavailable-find-device-modal.component.scss']
})
export class UnavailableFindDeviceModalComponent {

  constructor(
    protected dialogRef: NbDialogRef<UnavailableFindDeviceModalComponent>
  ) { }

  cancel(): void {
    this.dialogRef.close();
  }
  
}
